import { combineReducers } from 'core/redux'

import comments from './comments'
import kbSearch from './kbSearch'

export default combineReducers({
  comments,
  kbSearch,
})
